const en = {
	Previous: "Previous",
	Next: "Next",
	Consent: "Consent",
	"Consent Line 1":
		"You will go through a series of steps to complete your background check. Rest assured, your progress will be saved as you proceed. You can confidently exit and return to the process until you submit your application.",
	"Consent Line 2":
		"After submitting your details, we will start processing your background screening report. Your personal information will be handled in compliance with our Terms of Use and Privacy Policy. Before you start, please verify that:",
	"Consent Selection 1": "I have read, understood, and agreed to the Privacy Policy and Terms of Service",
	"Consent Selection 2": "I am over 18 years",
	"Consent Selection 3": "This is not a Vulnerability Sector Check (VSC)",
	"Consent Error Line": "You must check all boxes if you want to proceed",
	"Personal Information": "Personal Information",
	"Enter First Name":
		"Please enter your first name (given name) only. This should match your government issued ID. Do not enter nicknames or initials in this section. If you do not have a first name enter a period '.'",
	"First Name Label": "First Name",
	"Middle Name Label": "Middle Name",
	"Enter Last Name":
		"Please enter your last name. This can also be referred to as Family Name or Surname. Enter your legal last name only, as it appears on your government issued ID.",
	"Last Name Label": "Last Name",
	"Enter Last Name at Birth":
		"Please enter your last name at birth ONLY if it differs from your current last name entered above. Your last name can also be referred to as your family name or surname at birth. This would be applicable to individuals who have legally changed their last name since birth.",
	"Last at Birth Label": "Last Name at Birth",
	Email: "Email",
	"Agree Email":
		"I agree that my results will be emailed to me at the email address I entered. I also understand that my personal information and confidential results will be exposed to this email address, as well as a unique URL pointing to your unique certificate.",
	"Agree Email Error": "You must check this box if you want to proceed",
	"Place of Birth: City": "Place of Birth: City",
	"Place of Birth: Country": "Place of Birth: Country",
	"Phone Number": "Phone Number",
	"Date of Birth": "Date of Birth",
	Gender: "Gender",
	"Reason and Organization Line": "Please enter the reason for the application and the organization requesting it.",
	"Purpose Label": "Purpose",
	"Organization Label": "Organization",
	"This field is required": "This field is required",
	"You need to be at least 18 years old": "You need to be at least 18 years old",
	"Address Information": "Address Information",
	"Address Information Requirements Line": "Please provide a comprehensive 5-year residential history, making sure there are no gaps in the information.",
	"Street Address Line 1": "Street Address Line 1",
	"Street Address Line 2": "Street Address Line 2",
	City: "City",
	"Province / State": "Province / State",
	"Postal / Zip Code": "Postal / Zip Code",
	Country: "Country",
	"Moved In Date": "Moved In Date",
	"Moved Out Date": "Moved Out Date",
	"Add Address": "Add Address",
	"Add a new Address": "Add a new Address",
	"Address Line 1": "Address Line 1",
	"Address Line 2": "Address Line 2",
	"Move In": "Moved In",
	"Move Out": "Moved Out",
	"Previous Offences": "Previous Offences",
	"Do not declare the following:": "Do not declare the following:",
	"Do Not declare line":
		"Absolute discharges or Conditional Discharges, pursuant to the Criminal Code, section 730. Any charges for which you have received a Pardon, pursuant to the Criminal Records Act. Any offences while you were a “young person” (12 years old but less than 18 years old), pursuant to the Youth Criminal Justice Act. Any charges for which you were not convicted, for example, charges that were withdrawn, dismissed, etc. Any provincial or municipal offences. Any charges dealt with outside of Canada.",
	"Have you ever been convicted": "Have you ever been convicted of a criminal offense for which a pardon has not been granted?",
	Yes: "Yes",
	No: "No",
	"Picture Upload": "Picture Upload",
	"Picture Upload Line 1":
		"To confirm your identity, we need to compare the picture from your identity document to a photo you will take of yourself. Do you agree to the following statement?",
	"Picture Upload Line 2":
		"By uploading this picture you understand and consent freely that my picture will be collected and processed on behalf of Police Certs via a biometric system based on facial recognition technology to identify me in photographs for the purposes of verifying my identity as part of my application.",
	"Capture Photo": "Capture Photo",
	Retake: "Retake",
	"Upload First ID": "Upload First ID",
	"Upload Second ID": "Upload Second ID",
	"Upload Front": "Upload Drivers License OR Resident Card OR Passport - Front.",
	"Upload Back": "Upload Drivers License OR Resident Card OR Passport - Back.",
	"Drag and Drop Here": "Drag and drop the file here, or click to select file.",
	"Click to Select File": "Click to Select File",
	"Upload Format": "Upload JPG/JPEG Format (Max 2MB).",
	Clear: "Clear",
	Review: "Review",
	"Review Information": "Please review the following information for accuracy:",
	"Full Name": "Full Name",
	Addresses: "Addresses",
	"Place of Birth": "Place of Birth",
	"Criminal Offences": "Criminal Offences",
	"Please review these details carefully.": "Please review these details carefully.",
	"First ID Front": "First ID Front",
	"First ID Back": "First ID Back",
	"Second ID Front": "Second ID Front",
	"Second ID Back": "Second ID Back",
	"Authorization and Consent": "Authorization and Consent",
	"Please read the following terms and conditions":
		"Please read the following terms and conditions. You may proceed after accepting all terms and conditions. Criminal Record and Judicial Matters Check (CRJMC) I have read and accept these terms and conditions",
	"Full Consent Text":
		"I hereby give my consent to the search of the RCMP National Repository of Criminal Records based on the provided name(s), date of birth, and associated information regarding my declared criminal record history. I acknowledge that this search is not confirmed by fingerprint comparison, which is the only definitive method to determine the existence of a criminal record in the National Repository of Criminal Records. I release and discharge all members and employees of the processing Police Service, Police Certs – a product of Gutenberg Certs Corp, and the RCMP (Royal Canadian Mounted Police) from any and all liability for any damages, losses, or injuries that may arise as a result of the disclosure of information by the processing Police Service to Police Certs and/or its agents. I confirm that the information provided in this application is accurate and truthful to the best of my knowledge and belief.",
	"Yes, I agree": "Yes, I agree.",
	Payment: "Payment Details",
	"Please select type": "Please select the type of Criminal Record Check (CRC) you’d like to be performed:",
	"Criminal Record Check (Standard CRC)": "Criminal Record Check (Standard CRC)",
	"Standard CRC Includes": "This check searches for an individual's criminal convictions under Canadian federal law. The information typically includes:",
	"Convictions for criminal offenses": "Convictions for criminal offenses",
	"The date and type of each conviction": "The date and type of each conviction",
	"The corresponding sentence or disposition, if available": "The corresponding sentence or disposition, if available",
	"Criminal Record and Judicial Matters Check (Extended CRC)": "Criminal Record and Judicial Matters Check (Extended CRC)",
	"Extended CRC Includes": "This check is more comprehensive than a standard criminal record check and includes information on:",
	"Criminal convictions": "Criminal convictions",
	"The date and type of each conviction": "The date and type of each conviction",
	"The corresponding sentence or disposition, if available": "The corresponding sentence or disposition, if available",
	"Outstanding charges and arrest warrants": "Outstanding charges and arrest warrants",
	"Absolute and conditional discharges (within the past 3 years)": "Absolute and conditional discharges (within the past 3 years)",
	"Court orders, such as peace bonds and probation orders": "Court orders, such as peace bonds and probation orders",
	"Check with organization":
		"Kindly check with the organization who requested the check to ensure that you’re receiving the correct CRC. There are no refunds available. Please note that taxes (HST) will apply in addition to the purchase price.",
	Confirm: "Confirm",
	"Standard CRC": "Standard CRC",
	"Extended CRC": "Extended CRC",
	"Use Prepaid Code": "Use Prepaid Code",
	Free: "Free",
	"Pay Now": "Pay Now",
	Summary: "Summary",
	"Total Amount": "Total Amount",
	"Payment processed":
		"Your payment has been successfully processed. In within 24 hours you will receive an email notifying you about your Criminal Record Check requested. If there are any issues or concerns, please email us at support@policecerts.com.",
	"Active Application": "Active Application",
	"Record History": "Record History",
};
export default en;
